export const COOKIES_STORAGE_KEY = 'cookiePreferences';

export const COOKIE_TYPES = {
  ESSENTIAL: 'ESSENTIAL',
  ANALYTICS: 'ANALYTICS',
};

export const COOKIES_CONFIG = {
  [COOKIE_TYPES.ESSENTIAL]: {
    title: { id: 'web.cookies.essentialTitle', defaultMessage: 'Essential' },
    description: {
      id: 'web.cookies.essentialDescription',
      defaultMessage:
        'We collect and process essential data useful for you to browse Fleetback, use its features, for the technical performance of the website, as well as for security purposes.',
    },
    checked: true,
    disabled: true,
  },
  [COOKIE_TYPES.ANALYTICS]: {
    title: { id: 'web.cookies.analyticsTitle', defaultMessage: 'Web performance and analytics' },
    description: {
      id: 'web.cookies.analyticsDescription',
      defaultMessage:
        'We use this data to improve the performance of our websites and services, as well as to conduct user experience and business-relevant analysis. These services collect information about how you use the website, like which pages you visited and which links you clicked on. Their sole purpose is to improve website functions. This includes cookies from third-party analytics services as long as the cookies are for the exclusive use of Fleetback.',
    },
    checked: false,
  },
};

export const PRIVACY_POLICY_LINK = 'https://www.fleetback.com/privacy-policy';

export const END_REQUEST = 'REQUEST';

export const SUCCESS_REQUEST = 'SUCCESS';

export const FAILURE_REQUEST = 'FAILURE';

export const NOTIFIABLE_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

export const DEFAULT_SUCCESS_MESSAGE_BY_METHOD = {
  POST: {
    id: 'web.calls.default.post',
    defaultMessage: 'Entity has been created with success'
  },
  PUT: {
    id: 'web.calls.default.put',
    defaultMessage: 'Entity updated'
  },
  PATCH: {
    id: 'web.calls.default.put',
    defaultMessage: 'Entity updated'
  },
  DELETE: {
    id: 'web.calls.default.delete',
    defaultMessage: 'Entity deleted'
  },
};

export const DEFAULT_FAILURE_MESSAGE = {
  id: 'web.calls.default.failure',
  defaultMessage: 'Oops! Something went wrong.'
};
